import { Box, FormControlLabel, RadioGroup, Stack } from "@mui/material";
import Radio from "@mui/material/Radio";
import { useState, useEffect } from "react";
import ProfileMapping from "./mapping/ProfileMapping";
import ParameterMapping from "./mapping/ParameterMapping";
import SmartReportConfig from "./productConfig/SmartReportConfig";
import VizAppConfig from "./productConfig/VizAppConfig";
import ColorConfig from "./productConfig/ColorConfig";
import AssetManagement from "./assetManagament/AssetManagement";
import { markNextCallsAsIgnored } from "../../lib/activityLogQueryParam";

const ProductConfig = () => {
  const [productType, setProductType] = useState("smartreport");

  useEffect(() => {
    markNextCallsAsIgnored(5000);
  }, [productType]);

  const renderSpecificProductType = () => {
    switch (productType) {
      case "smartreport":
        return <SmartReportConfig />;
      case "vizapp":
        return <VizAppConfig />;
      case "color":
        return <ColorConfig />;
      default:
        return <SmartReportConfig />;
    }
  };
  return (
    <Stack>
      <Box pl={2}>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={productType}
          onChange={(e) => setProductType(e.target.value)}
        >
          <FormControlLabel
            value="smartreport"
            control={<Radio />}
            label="Smart Report"
          />
          <FormControlLabel
            value="vizapp"
            control={<Radio />}
            label="Viz App"
          />
          <FormControlLabel value="color" control={<Radio />} label="Color" />
        </RadioGroup>
      </Box>
      {renderSpecificProductType()}
      
      <AssetManagement />

    </Stack>
  );
};

export default ProductConfig;
